import { createContext, ReactElement, useMemo } from "react";
import { FilterBody } from "../../../../../hooks/filter/typing";
import { InputModel } from "../../../../../utils/types";
import { Item } from "../../../../../utils/types/generals";
import { formatFilter } from "../pages/main/constans/constants"
import { useFilter } from "../../../../../hooks/filter";
import { useGetData } from "../pages/main/hooks/getData";

interface ServiceContextType {
    //Filters
    filterCatalog: FilterBody
    CatalogData: {
        items: {
            [x: string]: Item[];
        };
        input: {
            [x: string]: InputModel;
        };
        getData: () => Promise<void>;
    }
  }

const ServiceContext = createContext<ServiceContextType>({} as ServiceContextType);


const ServiceProvider = ({ children }: { children: ReactElement }) => {

  //Filters
  const CatalogData = useGetData()
  const filterCatalog = useFilter({ formatFilter })

  const value = useMemo(() => ({  CatalogData, filterCatalog }), [
    CatalogData, 
    filterCatalog,
  ]);

  return (
    <ServiceContext.Provider value={value}>
      {children}
    </ServiceContext.Provider>
  );
};

export { ServiceContext, ServiceProvider };
